










































































































































































































































































































































import * as PageDefinition from "../Infrastructure/PageDefinition";
import { SettingFilter, Vue, Component, MenuService, GlobalSearchService, TenantService, TenantFilter, logoutCurrentUser, RightHelper, Prop, Watch, UserService, NotificationSendService, NotificationSendFilter } from "../Infrastructure/CorBase/CoreBase";

interface iGlobalSearch {
	isMore: boolean;
	items: iGlobalItemSearch[];
}

interface iGlobalItemSearch {
	id: number;
	name: string;
	description: boolean;
	typeObject: string;
}

//VaPTODO - proc se nedela import store z CoreBase???
import store from "../Infrastructure/CorBase/StoreBase";

@Component({
	components: {
		Keypress: () => import('vue-keypress')
	}
})
export default class TopMenuLight extends Vue {
	@Prop({ type: String, required: false, default: "" }) initPage?: string; //identifikace ze probehl login a muze se nacist jazykovy enums

	CopyrightYear = PageDefinition.CopyrightYear;
	menuService: MenuService = new MenuService();
	tenantService: TenantService = new TenantService();
	userService: UserService = new UserService();
	globalSearchService: GlobalSearchService = new GlobalSearchService();
	notificationSendService: NotificationSendService = new NotificationSendService();

	idLoggedUser: number = -1;
	hasContentModule: boolean = false;
	hasReceiverModule: boolean = false;
	hasTaskModule: boolean = false;

	showLanguageMenu: boolean = false;
	timer = 0;
	timerSetting = 0;
	showSettingMenu: boolean = false;
	showSettingSubMenu: boolean = false;

	showNotificationMenu: boolean = false;

	idTenant = 0;
	tenantList = [{ value: 0, text: 'prvni', identif: '' }];

	searchItems: iGlobalSearch = { isMore: false, items: [] };
	notificationCount = 0;
	search = "";
	showSearchItems = true;

	@Watch('$store.state.globalSearch')
	onPropertyTest(value: string, oldValue: string) {
		if (value != oldValue) {
			this.search = this.$store.state.globalSearch;
		}
	}

	getVersionNumber() {
		//this.versionNumber = "";
		return this.$t('global.version').toString() + " " + this.$store.state.versionNumber;
	}

	notificationList: { id: number, name: string }[] = []
	timerHandle = 0;

	goToAllNotifikaci() {
		this.$router.push({ name: PageDefinition.PAGE_NotificationViewList });
		this.changeVisibilityNotificationMenu();
	}

	goToDetailNotification(id: any) {
		this.changeVisibilityNotificationMenu();
		this.$router.push({ name: PageDefinition.PAGE_NotificationViewDetail, query: { id: id } });
	}

	hoverNotification() {
		this.changeVisibilityNotificationMenuShow();
	}

	leaveNotification() {
		this.changeVisibilityNotificationMenuHide();
	}

	loadNotifications() {
		if (store.state.idPerson > 0 && store.state.idTenant > 0) {
			var filter = new NotificationSendFilter(store.state.idPerson, store.state.idTenant, true, true);
			this.notificationSendService.getAllByFilter(filter).then(res => {
				this.notificationList = [];
				for (var i = 0; i < res.data.length; i++) {
					this.notificationList.push({ id: res.data[i].id, name: res.data[i].subjectText })
				}
				this.notificationCount = this.notificationList.length;
				store.commit("notificationCount", this.notificationCount);
			});
		}
	}

	beforeDestroy() {
		this.clearNotificationTimer();
	}

	searchDynamic = '';
	dynamicID() {
		var id = 'dynamicID-' + (Math.floor(Math.random() * Date.now()));
		this.searchDynamic = id;
		return id;
	}

	closeNotification(id: number) {
		this.notificationSendService.readNotifications([id]).then(res => {
			if (res.data) {
				this.notificationCount = this.notificationCount - 1;
				this.notificationList = this.notificationList.filter(c => c.id != id);
			}
		});
	}

	seachWorld = this.$t('topMenu.settingSearchWord').toString();

	goToGlobalSearch() {
		this.showSearchItems = false;
		this.$router.push({ name: PageDefinition.PAGE_GlobalSearchList, query: { search: this.search } });
	}

	allSearchItemName() {
		return this.$t('topMenu.searchAllItems') + " \"" + this.search + "\"";
	}

	searchEnterDown() {
		document.getElementById(this.searchDynamic)!.blur();
		this.goToGlobalSearch();
	}


	isSearching = false;
	focusLostSearch() {
		if (this.showSearchItems && this.allowLostFocus && !this.isSearching) {
			this.timer = setTimeout(() => {
				if (!this.isClickRemove) {
					this.showSearchItems = false;
				}
				else {
					this.isClickRemove = false;
				}
			}, 800);
		}
	}
	isClickRemove = false;
	allowLostFocus = true;
	removeSearch() {
		this.allowLostFocus = false;
		this.isClickRemove = true;
		this.search = "";
		this.$nextTick(() => {
			document.getElementById(this.searchDynamic)!.focus();
			//this.showSearchItems = true;
			this.showSearchItems = false;
		});

		//proc
		this.timer = setTimeout(() => {
			this.allowLostFocus = true;
		}, 800);

		this.$store.commit("globalSearch", "");
	}

	classSearchTypeIcon(item: iGlobalItemSearch) {
		if (item.typeObject == "Task") {
			return "searchTypeTask";
		}
		else if (item.typeObject == "Receiver") {
			return "searchTypeReceiver";
		}
		else if (item.typeObject == "Content") {
			return "searchTypeContent";
		}
		else if (item.typeObject == "Tag") {
			return "searchTypeTag";
		}
	}

	selectItemObject(item: iGlobalItemSearch) {
		if (item.typeObject == "Task") {
			this.$router.push({ name: 'TaskDetail', query: { id: item.id.toString() } });
		}
		else if (item.typeObject == "Receiver") {
			this.$router.push({ name: 'ReceiverDetail', query: { id: item.id.toString() } });
		}
		else if (item.typeObject == "Content") {
			this.$router.push({ name: 'ContentDetail', query: { id: item.id.toString() } });
		}
		else if (item.typeObject == "Tag") {
			this.$router.push({ name: 'TagDetail', query: { id: item.id.toString() } });
		}
		this.showSearchItems = false;
	}

	clickSearchInput() {
		this.showSearchItems = true;
	}

	showSearch() {
		return this.search.replace(' ', '').length != 0 && this.searchItems.items.length != 0 && this.showSearchItems == true;
	}

	showMoreSearch() {
		return this.showSearch() && this.searchItems.isMore;
	}


	changeSearch(item: string) {
		store.commit("globalSearch", item);
		if (item.length > 0) {
			this.showSearchItems == true;
		}
		if (item.replaceAll(' ', '').length != 0) {
			this.isSearching = true;
			this.globalSearchService.getSearchWorld(store.state.idTenant, item, store.state.ignoreDiacritics, store.state.globalSearchItemCount).then(res => {
				this.searchItems = res.data;
				this.$nextTick(() => {
					document.getElementById(this.searchDynamic)!.focus();

					this.showSearchItems = true;
					this.isSearching = false;
				});
			});
		}
		else {
			this.searchItems.items = [];
			this.searchItems.isMore = false;
			this.$nextTick(() => {
				document.getElementById(this.searchDynamic)!.focus();
			});
		}
	}

	userName() {
		return store.state.fullNameOrLogin;
	}

	tenantName() {
		var tenantName = '';
		if (store.state.tenantList.length > 0) {
			tenantName = store.state.tenantList.filter((c: any) => c.value == store.state.idTenant)[0].identif;
		}
		return tenantName;
	}

	styleTesting() {
		return store.state.isTestEnvironment ? "background-color:darkcyan;" : "";
	}

	isSelectedLang(lang: string) {
		return store.state.currentLanguage == lang;
	}

	//zobrazeni vybraneho jazyka
	classLangIcon(lang: string) {
		var result = "buttonMainMenu ";
		if (lang == store.state.currentLanguage) {
			result += "buttonMainMenuSelected"
		}
		return result
	}

	showLangIcon(lang: string) {
		return store.state.tenantLanguages.indexOf(lang) != -1;
	}

	openLink(link: string) {
		window.open(link, "_blank");
	}

	clickLangIcon(lang: string): void {
		store.commit('setLanguage', lang);
		this.$i18n.locale = lang;
		this.prepareEnums();
	}
	originIdentifTenant = '';
	actualLoadTenant = false;
	initTenantList() {
		this.tenantList = store.state.tenantList;

		if (store.state.tenantList.length == 0 && store.state.idUser > 0) {
			this.actualLoadTenant = true;
			var filterTenant = new TenantFilter(false);
			this.tenantService.getAllByFilter(filterTenant).then(res => {
				this.originIdentifTenant = res.data.filter((c: any) => c.id == store.state.idTenant)[0].identifier;
				var originTenant = this.originIdentifTenant + this.$t('topMenu.tenantDefaut').toString();

				this.actualLoadTenant = false;
				this.tenantList = [];
				var list = (res.data as Array<any>);
				this.tenantList.push({ value: store.state.idTenant, text: originTenant, identif: this.originIdentifTenant });
				for (var i = 0; i < list.length; i++) {
					if (this.originIdentifTenant.toString() != list[i].identifier) {
						this.tenantList.push({ value: list[i].id, text: list[i].identifier, identif: list[i].identifier });
					}
				}
				this.$store.commit("setTenantList", this.tenantList);
				this.idTenant = this.tenantList[0].value;
			})
		}
		if (this.isSuperUser() && this.idTenant == 0) {
			this.idTenant = store.state.idTenant;
		}
	}

	selectUserProfile() {
		var idQueary = this.$route.query['id'];
		var result = store.state.idUser == Number(idQueary);
		return result;
	}

	settingPages = ['UserList', 'SettingUserList', 'SettingTenantList', 'SettingGlobalList', 'UserDetail', 'SettingList', 'SettingDetail', 'RoleList', 'RoleDetail', 'GroupList', 'GroupDetail', 'EnumList', 'EnumDetail', 'NationalHolidayList', 'NationalHolidayDetail', 'TagList', 'TagDetail', 'TenantList', 'TenantDetail', 'LoginHistoryList', 'CertificateDetail', 'ComponentList', 'ComponentDetail', 'ChangeLogList', 'ChangeLogDetail'];
	selectPageList() {
		return this.settingPages.indexOf(String(this.$route.name)) != -1 || this.showSettingMenu;
		//return this.showSettingMenu;
		//         if (this.$router.currentRoute.name == PageDefinition.PAGE_UserDetail && store.state.idUser == Number(this.$route.params['id'])) {
		//	return false;
		//}
		//         return this.settingPages.indexOf(String(this.$route.name)) !=-1;
	}

	selectPageNotificationList() {
		return this.showNotificationMenu;
	}

	selectedPage(page: string, page2: string | undefined = undefined) {
		return (page == this.$route.name || page2 == this.$route.name);
		// return !this.showSettingMenu && (page == this.$route.name || page2 == this.$route.name);
	}

	selectedPageReceiverNotAssigned(page: string, page2: string) {
		return (page == this.$route.name || page2 == this.$route.name) && store.state.notAssigned;
	}

	selectedPageSetting(page: string, page2: string | undefined = undefined, isGlobal: boolean | undefined = undefined) {
		var isGlobalSetting = store.state.settingType == 'global';
		return (page == this.$route.name || page2 == this.$route.name) && isGlobalSetting == isGlobal;
	}

	//možne jazyky - tady doplnit az budou dalsi ikony
	allIcons = [
		{ id: 1, name: 'CS', src: "menu_jazyk_cs_poz.svg", tooltip: 'čeština' },
		{ id: 2, name: 'DE', src: 'menu_jazyk_de_poz.svg', tooltip: 'němčina' },
		{ id: 3, name: 'EN', src: 'menu_jazyk_en_poz.svg', tooltip: 'angličtina' },
		{ id: 4, name: 'SK', src: 'menu_jazyk_sk_poz.svg', tooltip: 'slovenština' }
	];

	icons = [{ id: 1, name: 'CS', src: "menu_jazyk_cs_poz.svg", tooltip: 'čeština' }];

	selectMenuSetting = -1;
	lastSelectMenuSetting = -1;

	loginFormData = {
		tenantIdentifier: '',
		userLogin: '',
		userPassword: '',
		idTenant: 0
	};

	static readonly tenantChangeRoutes: {src?: string; dst: string }[] = [
		{ src: PageDefinition.PAGE_ReceiverDetail, dst: PageDefinition.PAGE_ReceiverList },
		{ src: PageDefinition.PAGE_TaskDetail, dst: PageDefinition.PAGE_TaskList },
		{ src: PageDefinition.PAGE_ContentDetail, dst: PageDefinition.PAGE_ContentList },
		{ src: undefined, dst: PageDefinition.PAGE_TaskList },
	];

	@Watch('idTenant')
	onPropertyIdTenant(value: string, oldValue: string) {
		if (value != oldValue && oldValue != '0') {
			//tohle je pro zamezeni focus a zobrazeni
			store.commit("globalSearch", '');
			var tenantIdentifier = this.tenantList.filter((c: any) => c.value == value).length > 0 ? this.tenantList.filter((c: any) => c.value == value)[0].text : '';

			this.loginFormData.tenantIdentifier = tenantIdentifier;
			this.loginFormData.userLogin = store.state.fullNameOrLogin;
			this.loginFormData.idTenant = Number(value);
			this.userService.changeTenant(this.loginFormData).then((response) => {
				var change = this.idTenant != store.state.idTenant;
				this.$store.commit("setIdTenant", this.idTenant);
				this.$store.commit("setTenantModules", response.data.moduleList);
				this.changeSearch(this.search);
				if (change) {
					var nameDes = this.$route.name as String;
					var query = this.$route.query;
					this.$router.push({ name: 'helpRefresh', query: query }).then(c => {
						nameDes = nameDes + '';
						let changeRoute = TopMenuLight.tenantChangeRoutes.find(c => c.src == nameDes)
							|| TopMenuLight.tenantChangeRoutes.find(c => c.dst == nameDes)
							|| TopMenuLight.tenantChangeRoutes.find(c => c.src == undefined);
						nameDes = changeRoute && changeRoute.dst || PageDefinition.PAGE_TaskList;
						this.$router.push({ name: nameDes + '', params: this.$route.query as any, query: query });
					});
				}
			}).catch((error) => {
			});
		}
	}

	getClassOpen() {
		var result = this.showSettingMenu || this.showNotificationMenu ? "topMenuClickBackground" : ";";
		return result;
	}


	private showMenu(menu: number): boolean {
		return menu == this.selectMenuSetting;
	}

	@Watch('initPage')
	onPropertyChangedInit(value: string, oldValue: string) {
		if (value != oldValue) {
			if (value != 'login') {
				this.$i18n.locale = store.state.currentLanguage;
				this.prepareEnums();
			}
		}
	}


	@Watch('$store.state.notificationCount')
	onStoreChangeNotificationCount(value: string, oldValue: string) {
		if (value != oldValue) {
			this.notificationCount = this.$store.state.notificationCount;
		}
	}

	@Watch('$store.state.notificationRefreshTimer')
	onStoreChangeNotificationRefreshTimer(value: string, oldValue: string) {
		if (value != oldValue) {
			this.setNotificationTimer();
		}
	}

	closeSettingsHide() {
		if (this.showSettingMenu) {
			this.changeVisibilitySettingMenu();
		}
		if (this.showNotificationMenu) {
			this.changeVisibilityNotificationMenu();
		}
	}

	closeSettings() {
		this.changeVisibilitySettingMenu();
	}

	private changeVisibilitysubMenuSetting(): void {
		if (this.lastSelectMenuSetting == this.selectMenuSetting || this.lastSelectMenuSetting == -1 || !this.showSettingSubMenu) {
			this.showSettingSubMenu = !this.showSettingSubMenu;
		}
		this.lastSelectMenuSetting = this.selectMenuSetting;
	}

	private changeVisibilitySettingAndNotificationMenuHide(): void {
		if (this.showSettingMenu) {
			this.changeVisibilitySettingMenu();
		}
		if (this.showNotificationMenu) {
			this.changeVisibilityNotificationMenu();
		}
	}

	private changeVisibilitySettingMenu(): void {
		this.showSettingMenu = !this.showSettingMenu;
		//TODO postupne zobrazeni
		const menu = document.querySelector('#settingMenu');
		if (this.showSettingMenu && this.showNotificationMenu) {
			this.changeVisibilityNotificationMenu();
		}
		//@ts-ignore
		menu.classList.toggle('show');
	}

	private changeVisibilityNotificationMenu(): void {
		this.showNotificationMenu = !this.showNotificationMenu;
		if (this.showNotificationMenu && this.showSettingMenu) {
			this.changeVisibilitySettingMenu();
		}
		if (this.showNotificationMenu) {
			this.loadNotifications();
		}

		//TODO postupne zobrazeni
		const menu = document.querySelector('#notificationMenu');

		//@ts-ignore
		menu.classList.toggle('show');
	}

	private changeVisibilityNotificationMenuShow(): void {
		this.showNotificationMenu = true;
		if (this.showNotificationMenu && this.showSettingMenu) {
			this.changeVisibilitySettingMenu();
		}
		this.loadNotifications();

		//TODO postupne zobrazeni
		const menu = document.querySelector('#notificationMenu');

		//@ts-ignore
		menu.classList.toggle('show');
	}

	private changeVisibilityNotificationMenuHide(): void {
		this.showNotificationMenu = false;

		//TODO postupne zobrazeni
		const menu = document.querySelector('#notificationMenu');

		//@ts-ignore
		menu.classList.toggle('hide');
	}

	mounted() {
		this.prepareEnums();
		this.initTenantList();
		this.setNotificationTimer();
		window.addEventListener('resize', () => {
			this.setHeightTableNextTick();
		});
		this.setHeightTableNextTick();
	}

	private getHeight(): string {
		return "height: " + this.heightScreen;
	}
	private getHeightSubMenu(): string {
		return "height: 100%; margin-top: -" + this.heightScreen;
	}

	heightScreen = "250px";
	private setHeightTable(): void {
		var height = window.innerHeight - 170 - 12;
		this.heightScreen = height + "px";
	}

	private setHeightTableNextTick(): void {
		this.$nextTick(() => {
			this.setHeightTable();
		});
	}

	private setNotificationTimer(): void {
		this.clearNotificationTimer();
		var timerRefresh = store.state.notificationRefreshTimer;
		if (timerRefresh < 30) {
			// Pokud prisla nejake hodnote z REST, tak nesmime dovolit mensi hodnotu nez 10
			if (timerRefresh > 0) {
				timerRefresh = 10;
			// Pokud NEprisla hodnote z REST nebo jsem na loginPage, tak nastavim 60
			} else {
				timerRefresh = 60;
			}
		}
		this.timerHandle = setInterval(() => {
			this.loadNotifications();
		}, timerRefresh * 1000);
	}

	private clearNotificationTimer(): void {
		if (this.timerHandle != 0) {
			clearInterval(this.timerHandle);
		}
	}

	prepareEnums(): void {
		var tenantLang = store.state.tenantLanguages;
		var curLang = this.currentLang();
		this.icons = [];

		for (var i = 0; i < tenantLang.length; i++) {
			if (this.allIcons.filter((c: any) => c.name == tenantLang[i]).length > 0 && curLang != tenantLang[i]) {
				this.icons.push(this.allIcons.filter((c: any) => c.name == tenantLang[i])[0]);
			}
		}
	}

	currentLang(): string {
		var curLang = store.state.currentLanguage == undefined || store.state.currentLanguage == '' || store.state.currentLanguage == '' ? 'EN' : store.state.currentLanguage;
		if (this.allIcons.filter((c: any) => c.name == store.state.currentLanguage).length == 0) {
			curLang = 'EN';
		}
		//posledni kontrola kdyz ani anglictina neni mezi povolene jazyky
		if (store.state.tenantLanguages.filter((c: any) => c == curLang).length == 0 && store.state.tenantLanguages.length > 0) {
			curLang = store.state.tenantLanguages[0];
		}
		this.$i18n.locale = curLang;
		return curLang;
	}

	pathSource(): string {
		var curLang = this.currentLang();
		//var curLang = store.state.currentLanguage == undefined || store.state.currentLanguage == '' || store.state.currentLanguage == '' ? 'EN' : store.state.currentLanguage;
		return this.allIcons.filter((c: any) => c.name == curLang)[0].src.replace('poz_zelna.svg', 'poz.svg');
	}

	enterImage(id: number) {
		var icon = this.icons.filter((c: any) => c.id == id)[0];
		icon.src = icon.src.replace('poz.svg', 'poz_zelna.svg');
		this.enterLangSet();
	}

	leaveImage(id: number) {
		var icon = this.icons.filter((c: any) => c.id == id)[0];
		icon.src = icon.src.replace('poz_zelna.svg', 'poz.svg');
	}
	//puvodni pak smazat
	clickLanguage(id: number): void {
		var lang = this.icons.filter((c: any) => c.id == id)[0];
		store.commit('setLanguage', lang.name);
		this.$i18n.locale = lang.name;
		this.prepareEnums();
		this.showLanguageMenu = false;
	}
	private enterLangSet(): void {
		clearTimeout(this.timer);
		this.showLanguageMenu = true;
	}

	private leaveLangMenu(): void {
		this.timer = setTimeout(() => {
			this.showLanguageMenu = false;
		}, 200);
	}

	showChangeLanguage(): void {
		this.showLanguageMenu = !this.showLanguageMenu;
	}


	goToPage(page: string) {
		this.changeVisibilitySettingAndNotificationMenuHide();
		//	this.showSettingMenu = false;
		if (page) {
			this.goToPageWithCheck(page);
		}
	}

	getCurrentRouteName(): string {
		let routeName = this.$router.currentRoute.name;
		if (routeName) {
			return routeName as string;
		}
		return '';
	}

	getLoggedUserId(): number {
		return this.$store.state.idUser;
	}

	isLoggedUser(): boolean {
		this.initTenantList();
		return this.$store.state.isLogged === true;
	}

	detailUserPage() {
		let idUser: any = this.getLoggedUserId();
		if (this.$router.currentRoute.name == PageDefinition.PAGE_UserDetail) {
			this.$router.push({ name: PageDefinition.PAGE_UserList }).then(res => {
				this.$router.push({ name: PageDefinition.PAGE_UserDetail, params: { id: idUser }, query: { id: idUser } });
			});
		}
		else {
			this.$router.push({ name: PageDefinition.PAGE_UserDetail, params: { id: idUser }, query: { id: idUser } });
		}
	}

	logout() {
		// pri uzivatelem vyzadanem odhlseni vymazeme i posledni navstivenou stranku, ta se totiz v ramci logoutu nemaze
		//this.$store.commit('clearLastRoutePage');
		if (this.getCurrentRouteName() != PageDefinition.PAGE_Login) {
			//	this.$router.go(0);
			logoutCurrentUser();
		}
	}

	goToPageWithCheck(pageDefinition: string) {
		if (this.getCurrentRouteName() != pageDefinition) {
			this.$router.push({ name: pageDefinition });
		}
	}

	showContentListLink(): boolean {
		return RightHelper.currentUserHasRight('CON_Content_Read') && this.hasContentModule;
	}

	showReceiverNotAssignedListLink(): boolean {
		return RightHelper.currentUserHasRight('CON_Receiver_Read') && this.hasReceiverModule && RightHelper.currentUserIsSuperUser();
	}

	showTemplateListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_NotificationTemplate_Read')
			&& RightHelper.currentUserHasModule('COR_NotificationTemplate');
	}

	showNotificationSettingDetail(): boolean {
		//TODO dodelat pravo
		return RightHelper.currentUserHasRight('COR_NotificationTemplate_Read');
	}

	showTaskListLink(): boolean {
		return RightHelper.currentUserHasRight('CON_Task_Read') && this.hasTaskModule;
	}

	showSettingLink(): boolean {
		return this.showMenuAuth()
			|| this.showMenuSet()
			|| this.showMenuLog()
			|| this.showMenuAdmin()
			|| this.showMenuPayment()
			|| this.showMenuLang();
		//return this.settingSignpost.hasSettingSignpostRight();
	}

	beforeMount() {
		// Pokud se prihlaseny uzviatel v aplikaci prepne na nejakou stranku tak, ze ji zapise do URL, pak se menu nevykresli
		this.reCreateMenu();
	}

	isSuperUser(): boolean {
		return RightHelper.currentUserIsSuperUser();
	}

	beforeUpdate() {
		this.reCreateMenu();
	}

	reCreateMenu() {
		//Nacteni menu a jeho rozporcování, ale pouze pro prihlaseneho uzivatele
		if (this.idLoggedUser != this.getLoggedUserId()) {
			this.idLoggedUser = this.getLoggedUserId();
			if (this.idLoggedUser > 0) {
				this.createMenu();
			}
		}
	}

	createMenu() {
		this.menuService.getById(this.idLoggedUser).then((response) => {
			this.hasContentModule = this.HasModulePart(response.data.topMenu, 'CON_Content');
			this.hasReceiverModule = this.HasModulePart(response.data.topMenu, 'CON_Receiver');
			this.hasTaskModule = this.HasModulePart(response.data.topMenu, 'CON_Task');
		}).catch((error) => {
		});
	}

	HasModulePart(topMenuData: any[], subMenuIdentifier: string): boolean {
		let menuList = topMenuData.filter((menu) => menu.subMenu.some((submenu: any) => submenu.identifier === subMenuIdentifier));
		if (menuList.length > 0) {
			return true;
		}
		return false;
	}


	// #region Nastaveni

	private showUserListLink(): boolean {

		return RightHelper.currentUserHasRight('COR_User_Read') &&
			RightHelper.currentUserHasModule('COR_User');
	};

	private goToUserListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_UserList });
		this.changeVisibilitySettingMenu();
	}

	private showGroupListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Group_Read') &&
			RightHelper.currentUserHasModule('COR_Group');
	};

	private goToGroupListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_GroupList });
		this.changeVisibilitySettingMenu();
	}

	private showRoleListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Role_Read') &&
			RightHelper.currentUserHasModule('COR_Role');
	};

	private goToRoleListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_RoleList });
		this.changeVisibilitySettingMenu();
	}

	private showEnumListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_EnuType_Read') &&
			RightHelper.currentUserHasModule('COR_EnuType');
	};

	private goToEnumListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_EnumList });
		this.changeVisibilitySettingMenu();
	}

	private showNationalHolidayListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_NationalHoliday_Read') &&
			RightHelper.currentUserHasModule('COR_NationalHoliday');
	};

	private goToNationalHolidayListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_NationalHolidayList });
		this.changeVisibilitySettingMenu();
	}

	private goToTemplateList(): void {
		this.$router.push({ name: PageDefinition.PAGE_NotificationTemplateList });
		this.changeVisibilitySettingMenu();
	}

	private goToNotificationSettingDetail(): void {
		this.$router.push({ name: PageDefinition.PAGE_NotificationSettingDetail, query: { type: 'detail' }, params: { type: 'detail' } });
		this.changeVisibilitySettingMenu();
	}

	private showTenantSettingListLink(): boolean {
		//ma to byt vzdy videt
		return RightHelper.currentUserHasRight('COR_Setting_Tenant')
			&& RightHelper.currentUserHasModule('COR_Tenant');
	};

	private goToTenantSettingListLink(): void {
		this.$store.commit("settingType", "tenant");
		this.$router.push({ name: PageDefinition.PAGE_SettingTenantList });
		//if (this.$router.currentRoute.name == PageDefinition.PAGE_SettingList) {
		//	//TODO najit lepsi řešení je to nějaké pomalé
		//
		//	this.$router.go(0);
		//}
		//else {
		//             this.$router.push({ name: PageDefinition.PAGE_SettingList, params: { type: "tenant" }, query: { type: "tenant" } });
		//}
		this.changeVisibilitySettingMenu();
	}

	private showReceiverListLink(): boolean {
		return RightHelper.currentUserHasRight('CON_Receiver_Read');
	};

	private showTagListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Setting_Tenant') ||
			RightHelper.currentUserHasModule('COR_Tag');
	};

	private showTenantpaidLink(): boolean {
		return RightHelper.currentUserHasRight('COR_TenantPaid')
			&& RightHelper.currentUserHasModule('COR_Tenant');
	};

	private goToTagListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_TagList });
		this.changeVisibilitySettingMenu();
	}

	private goToTenantpaidLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_TenantpaidDetail });
		this.changeVisibilitySettingMenu();
	}

	//přechod na neprirazene zařízení
	private goToReceiverListLink(notAssigned: boolean): void {
		this.$store.commit("notAssigned", notAssigned);
		if (this.$router.currentRoute.name == PageDefinition.PAGE_ReceiverList) {
			this.$router.go(0);
		}
		else {
			this.$router.push({ name: PageDefinition.PAGE_ReceiverList });
		}
		if (this.showSettingMenu) {
			this.changeVisibilitySettingMenu();
		}
	}

	private showChangeLogListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_ChangeLog_Read') &&
			RightHelper.currentUserHasModule('COR_ChangeLog');
	};

	private showStatisticsLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Setting_Tenant');
	};

	private goToChangeLogListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_ChangeLogList });
		this.changeVisibilitySettingMenu();
	}

	private goToStatisticsLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_StatisticsDetail });
		this.changeVisibilitySettingMenu();
	}

	//TODO doplnit prava
	private showNotificationViewListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_LoginHistory_Read') &&
			RightHelper.currentUserHasModule('COR_LoginHistory');
	};

	private showLoginHistoryListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_LoginHistory_Read') &&
			RightHelper.currentUserHasModule('COR_LoginHistory');
	};

	private goToLoginHistoryListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_LoginHistoryList });
		this.changeVisibilitySettingMenu();
	}

	private goToNotificationViewListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_NotificationViewList });
		this.changeVisibilitySettingMenu();
	}

	private showTenantListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Tenant_Read') &&
			RightHelper.currentUserHasModule('COR_Tenant');
	};

	private showNotificationPortalLink(): boolean {
		return RightHelper.currentUserHasRight('COR_NotificationSend_Update') &&
			RightHelper.currentUserHasModule('COR_NotificationSend');
	};	

	private goToNotificationPortal(): void {
		this.$router.push({ name: PageDefinition.PAGE_NotificationPortalDetail });
		this.changeVisibilitySettingMenu();
	}

	private goToTenantListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_TenantList });
		this.changeVisibilitySettingMenu();
	}

	private showSettingListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Setting_Global') &&
			RightHelper.currentUserHasModule('COR_Setting');
	};

	private showCertificateLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Setting_Global') && this.isSuperUser() ||
			RightHelper.currentUserHasRight('COR_Setting_Tenant');
	};

	private showVpnReservedLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Setting_Global');// ||	RightHelper.currentUserHasRight('COR_Setting_Tenant');
	};

	private goToSettingListLink(): void {
		this.$store.commit("settingType", "global");
		this.$router.push({ name: PageDefinition.PAGE_SettingGlobalList });
		//if (this.$router.currentRoute.name == PageDefinition.PAGE_SettingList) {
		//	this.$store.commit("settingType", "global");
		//	this.$router.go(0);
		//}
		//else {
		//	this.$router.push({ name: PageDefinition.PAGE_SettingList, params: { type: "global" }, query: { type: "global" } });
		//}
		this.changeVisibilitySettingMenu();
	}

	private showComponentListLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Component_Read') &&
			RightHelper.currentUserHasModule('COR_Component');
	};

	private goToComponentListLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_ComponentList });
		this.changeVisibilitySettingMenu();
	}

	private goToCertificateLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_CertificateDetail, query: { id: store.state.idTenant.toString() } });
		this.changeVisibilitySettingMenu();
	}

	private goToVpnReservedLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_VpnReservedList });
		this.changeVisibilitySettingMenu();
	}

	private goToGeneralTermLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_GeneralTermList });
		this.changeVisibilitySettingMenu();
	}

	private showGeneralTermLink(): boolean {
		return RightHelper.currentUserHasRight('COR_GeneralTermsandCondition_Update') && this.isSuperUser();
	};

	private goToSellerLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_SellerList });
		this.changeVisibilitySettingMenu();
	}

	private showSellerLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Seller_Update') || this.isSuperUser() == true;
	};

	private goToTariffLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_TariffList });
		this.changeVisibilitySettingMenu();
	}

	private goToPricelistTemplateLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_PricelistTemplateList });
		this.changeVisibilitySettingMenu();
	}

	private goToPricelistLink(): void {
		this.$router.push({ name: PageDefinition.PAGE_PricelistList });
		this.changeVisibilitySettingMenu();
	}

	private showTariffLink(): boolean {
		return RightHelper.currentUserHasRight('COR_Seller_Update') || this.isSuperUser() == true;
	};

	private showMenuAuth(): boolean {
		return this.showUserListLink()
			|| this.showGroupListLink()
			|| this.showRoleListLink();
	}

	private showMenuSet(): boolean {
		return this.showEnumListLink()
			|| this.showNationalHolidayListLink()
			|| this.showTenantSettingListLink()
			|| this.showTenantpaidLink()
			|| this.showTagListLink()
			|| this.showReceiverNotAssignedListLink()
			|| this.showTemplateListLink()
			|| this.showNotificationSettingDetail();
	}

	private showMenuLog(): boolean {
		return this.showChangeLogListLink()
			|| this.showLoginHistoryListLink()
			|| this.showNotificationViewListLink()
			|| this.showStatisticsLink();
	}

	private showMenuAdmin(): boolean {
		return this.showNotificationPortalLink()
			|| this.showGeneralTermLink()
			|| this.showTenantListLink()
			|| this.showSettingListLink()
			|| this.showComponentListLink()
			|| this.showCertificateLink()
			|| this.showVpnReservedLink();
	}

	private showMenuLang() : boolean {
		return this.showLangIcon('CS')
			|| this.showLangIcon('EN')
			|| this.showLangIcon('SK')
			|| this.showLangIcon('DE')
			|| this.showLangIcon('KO');
	}

	private showMenuPayment(): boolean {
		return this.isSuperUser();
	}

	// #endregion
}
